import React from 'react';
import Input from '../input/input.jsx';
import css from './signup-card.scss';
import email from '../../assets/images/f_email.svg';
import password from '../../assets/images/f_password.svg';
import username from '../../assets/images/f_username.svg';
import mailto from '../../assets/images/f_mailto.svg';
import google from '../../assets/images/f_google.svg';
import facebook from '../../assets/images/f_facebook.svg';
import apple from '../../assets/images/f_apple.svg';
import LoginButton from '../../components/button/button';
import SocialButton from '../../components/button/button';
import { Link } from 'react-router-dom';
import auth from '../../store/auth.js'

class SignupCard extends React.Component {
    render() {
        return (
            <div className={css.root}>
                <h1>Регистрационная карточка</h1>
                <form action="#" noValidate className={css.form}>
                    <Input id="email" img={email} caption="Email" captionDescription="ваш email не будет отображаться другим участникам" type="email" required errors />
                    <Input id="password" img={password} caption="Пароль" type="password" required errors />
                    <Input id="username" img={username} caption="Имя пользователя" captionDescription="можно использовать анонимное имя" type="text" required errors />
                    <Input id="useragreement" caption={<span>Я <em>согласен</em> с <a target="_blank"
                        rel="noopener noreferrer"
                        href="https://victoriasmedical.ai/documents/terms-and-conditions-v06-ru.html">условиями
                                                использования</a> сервиса VictoriasMedical.ai, нашими политиками <a
                            target="_blank" rel="noopener noreferrer"
                            href="https://victoriasmedical.ai/documents/privacy-policy-v06-ru.html">конфиденциальности</a> и использования файлов <a target="_blank" rel="noopener noreferrer"
                            href="https://victoriasmedical.ai//documents/cookie-policy-v06-ru.html">
                            Cookie</a></span>}
                        imgType='checkbox' type="txt" required errors />
                    <Input id="required" txt='*' caption="обязательные для заполнения поля" type="txt" />
                    <LoginButton style={css.button} onClick={() => { auth.login() }}
                        caption='Зарегистрироваться'>
                    </LoginButton>
                    <Link className={css.form__link} to="/">Уже зарегистрированы? Войти</Link>
                </form>

                <div className={css.OR}>
                    <span>или</span>
                </div>

                <div className={css.socialSign}>
                    <SocialButton style={`${css.socialSign__btn} ${css.socialSign__btn__google}`} onClick={() => { auth.login() }}
                        caption='Регистрация с Google' img={google} name="google">
                    </SocialButton>
                    <SocialButton style={`${css.socialSign__btn} ${css.socialSign__btn__facebook}`} onClick={() => { auth.login() }}
                        caption='Регистрация с Facebook' img={facebook} name="facebook">
                    </SocialButton>
                    <SocialButton style={`${css.socialSign__btn} ${css.socialSign__btn__apple}`} onClick={() => { auth.login() }}
                        caption='Регистрация с Apple' img={apple} name="apple">
                    </SocialButton>
                </div>
                <div className={css.mailto}>
                    <img src={mailto} alt="mailto" />
                    <a className={css.form__link} href="mailto:support@victoriasmedical.ai">support@victoriasmedical.ai</a>
                </div>
            </div>
        );
    }
}

export default SignupCard;


